import { useQuery } from 'vue-query';
import { reactive } from '@vue/composition-api';
import { getSearchWordList } from '@/api/common/search';

export default function useSearchWordList({} = {}) {
	const queryKey = reactive(['getSearchWordList']);

	const options = reactive({});

	const fetchList = async () => {
		const response = await getSearchWordList({
			searchWordTypeCd: 'POP',
		});

		const { code, message, result } = response;

		if (code !== 'SUC0000') {
			throw new Error(`${code}: ${message}`);
		}

		return result.couponWordList;
	};

	return useQuery(queryKey, fetchList, options);
}
